import { Storage } from 'aws-amplify';

import { TRequest } from 'src/types';

import { useQuery } from './useQuery';

export const getSubmittedAIRequests = async () => {
  let promises: any = [];
  //let currentYear = new Date().getFullYear();
  //let startingYear = 2018;

  const yearBatch = ['2018', '2019', '2020', '2021', '2022/0', '2022/1', '2022/2', '2022/3', '2022/4', '2022/5', '2022/6', '2022/7',
    '2022/8', '2022/9', '2022/10', '2022/11', '2023'];


  yearBatch.forEach((year) => {
    promises.push(Storage.list(year, { maxKeys: 'ALL' }));
  });
  /*for (startingYear = 2018; startingYear <= currentYear; startingYear++) {
    promises.push(Storage.list(startingYear.toString()));
  }*/

  try {
    const sList = await Promise.all(promises);
    const fList: TRequest[] = [];
    sList.flat().forEach((data: any) => {
      let parts = data.key.split('/');
      let found = false;
      fList.map((exist) => {
        if (exist.userId === parts[2] && exist.categoryId === parts[3]) {
          let time = parseInt(parts[5], 10);
          if (exist.time < time) {
            exist.time = time;
            exist.link = data.key;
            exist.size = data.size;
          }

          if (exist.submittedTime > time) {
            exist.submittedTime = time;
          }

          found = true;
        }

        return exist;
      });

      if (!found) {
        fList.push({
          year: parts[0],
          month: parts[1],
          userId: parts[2],
          categoryId: parts[3],
          time: parseInt(parts[5], 10),
          submittedTime: parseInt(parts[5], 10),
          link: data.key,
          size: data.size,
        });
      }
    });

    return fList.sort((a: TRequest, b: TRequest) => a.submittedTime - b.submittedTime);
  } catch (error: any) {
    if (error.statusCode === 403) {
      alert('You are not approved to access the application yet. Please contact XPM@collegeboard.org.');
    }
    throw error;
  }
};

export const useGetSubmittedAIRequests = () => {
  return useQuery<TRequest[]>({ query: getSubmittedAIRequests });
};
